import siteSearchIndexImport from "../data/searchFiles/siteSearchIndex.js";

const siteSearchIndex = Array.isArray(siteSearchIndexImport)
  ? siteSearchIndexImport
  : siteSearchIndexImport?.default || [];

function normalizeText(value = "") {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[’']/g, "")
    .replace(/[^a-z0-9\s-]/g, " ")
    .replace(/\s+/g, " ");
}

export function findBestSearchMatch(query) {
  const matches = getSearchSuggestions(query, 1);
  return matches.length ? matches[0] : null;
}

export function getSearchSuggestions(query, limit = 6) {
  const normalizedQuery = normalizeText(query);
  if (!normalizedQuery) return [];

  const queryWords = normalizedQuery.split(" ").filter(Boolean);

  const scored = siteSearchIndex
    .map((item) => {
      const title = normalizeText(item.title);
      const keywords = (item.keywords || []).map(normalizeText);

      let score = 0;

      if (title === normalizedQuery) score += 100;
      if (keywords.includes(normalizedQuery)) score += 90;
      if (title.startsWith(normalizedQuery)) score += 50;
      if (title.includes(normalizedQuery)) score += 35;

      keywords.forEach((keyword) => {
        if (keyword.startsWith(normalizedQuery)) score += 25;
        else if (keyword.includes(normalizedQuery)) score += 15;
      });

      queryWords.forEach((word) => {
        if (title.includes(word)) score += 8;
        keywords.forEach((keyword) => {
          if (keyword.includes(word)) score += 5;
        });
      });

      return { ...item, score };
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);

  return scored;
}